import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'
import 'swiper/css/thumbs'

// Theme
import '@styles/index.css'

import mobileBar from '@scripts/components/mobile-bar'
import siteHeader from "@scripts/components/site-header";
import scrollReveal from "@scripts/components/scroll-reveal";
import siteAnnouncementBar from "@scripts/components/site-announcement-bar";
import siteMenu from "@scripts/components/site-menu";

mobileBar.init()
siteHeader.init();
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  scrollReveal.init();
}
siteAnnouncementBar.init();
siteMenu.init();

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.documentElement.classList.remove('_preload')
  }, 250)

  const setHeights = () => {
    const siteHeader = document.querySelector(".site-header");

    if (siteHeader) {
      document.documentElement.style.setProperty("--site-header-height", `${Math.ceil(siteHeader.offsetHeight)}px`);
    }
  };

  window.addEventListener("resize", setHeights);

  setHeights();
})

const pageHas = (selector) => {
  return document.querySelectorAll(selector).length;
};

const loadComponents = async () => {
  if (pageHas("[data-scroll]")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-scroll-to" */ "@scripts/components/scroll-to"
    );

    component.init();
  }

  if (pageHas('[data-counter]')) {
    const { default: component } = await import(
      /* webpackChunkName: "components-count-up" */ '@scripts/components/count-up'
    )

    component.init();
  }

  if (pageHas(".media-slider")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-media-slider" */ "@scripts/components/media-slider"
    );

    component.init();
  }

  if (pageHas("[data-modal]")) {
    const { default: component } = await import(/* webpackChunkName: "components-modal" */ "@scripts/components/modal");

    component.init();
  }

};

loadComponents();
